module.exports = __webpack_public_path__ + "static/media/shape0_2.be63f9d8.obj";